import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ModalModule } from 'ngx-bootstrap/modal';

import { EventsModule } from '®shared/events';
import { ReadingListModule } from '®shared/reading-list/models';
import { TrapFocusModule } from '®shared/trap-focus';

import { ListDetailsEditorModalComponent } from './list-details-editor-modal.component';
import { ListDetailsEditorComponent } from './list-details-editor.component';
import { ListDetailsEditorEffects } from './list-details-editor.effects';
import { listDetailsEditorReducer } from './list-details-editor.reducer';
import {
  STATE_FEATURE_LIST_DETAILS_EDITOR,
  getInitialListDetailsEditorState,
} from './list-details-editor.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ListDetailsEditorEffects]),
    EventsModule,
    ModalModule,
    ReactiveFormsModule,
    ReadingListModule,
    StoreModule.forFeature(
      STATE_FEATURE_LIST_DETAILS_EDITOR,
      listDetailsEditorReducer,
      {
        initialState: getInitialListDetailsEditorState,
      },
    ),
    TrapFocusModule,
  ],
  declarations: [ListDetailsEditorComponent, ListDetailsEditorModalComponent],
  exports: [ListDetailsEditorComponent, ListDetailsEditorModalComponent],
})
export class ListDetailsEditorModule {}
